import React, { Component } from "react";
import { Button, Form, Modal, Row, Alert, Input } from "antd";
import CloseIcon from "../../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setkeyboardEnabled } from "../../../actions/AppAction";
import { sendShareAssets } from "../../../actions/AssetsShareAction";
import { getNewPermission, sendNotification } from "../../../utils/index";
import { editFolder } from "../../../actions/ClientAction";
import { cleanDataBackRoot, getRoot } from "../../../actions/AssetsRootAction";
import { getExplore } from "../../../actions/AssetsExploreAction";
import { moveFolder } from "../../../actions/ClientAction";
import Breadcrumb from "../../breadcrumb/Breadcrumb";
import SVGView from "../../assets-view/SVGView";
import { VideoView } from "../../assets-view/VideoView";
import DocumentView from "../../document-view/DocumentView";
import fileextension from "file-extension";
import "./MoveModal.css";

class MoveModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      targetFolderId: null,
      folderId: props.selectedFile._id
    };
  }

  handleOnMove = () => {
    const {
      workclient,
      selectedFile,
      user,
      newMatrix,
      intl,
      root
    } = this.props;

    const { targetFolderId } = this.state;
    const isBunker =
      selectedFile.type === "folder" || selectedFile.type === "bunker";
    if (
      selectedFile._id === targetFolderId &&
      selectedFile._id !== null &&
      targetFolderId !== null
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_select_different" })
      );
      return;
    }
    if (selectedFile._id === null && targetFolderId === null) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "no_folder_selected" })
      );
      return;
    }
    const isDestinationASon = this.isFolderDestinationASon(
      targetFolderId,
      selectedFile.parents
    );

    if (isDestinationASon) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "cannot_move_folder" })
      );
      return;
    }

    if (selectedFile._id) {
      const canMoveToFolder =
        user.clientRole !== "admin"
          ? getNewPermission(selectedFile._id, newMatrix, "moveFolder")
          : true;
      const canMoveFolderDestination =
        user.clientRole !== "admin" && user.role !== "admin"
          ? getNewPermission(targetFolderId, newMatrix, "moveFolder")
          : true;
      if (canMoveToFolder && canMoveFolderDestination) {
        // Si no hay carpeta de destino y el usuario es Admin la mueve a los Bunkers
        if (
          !targetFolderId &&
          user.role === "admin" &&
          user.clientRole === "admin"
        ) {
          this.props.moveFolder(
            workclient,
            selectedFile._id,
            root,
            null,
            root,
            intl,
            this.handleOnHideModal
          );
          // Si hay carpeta de destino y el usuario es Admin
        } else if (
          targetFolderId &&
          user.role === "admin" &&
          user.clientRole === "admin"
        ) {
          this.props.moveFolder(
            workclient,
            selectedFile._id,
            targetFolderId,
            null,
            root,
            intl,
            this.handleOnHideModal
          );
          // Si no hay carpeta de destino y el usuario es Operador
        } else if (
          !targetFolderId &&
          user.role === "operator" &&
          user.clientRole === "admin"
        ) {
          this.props.moveFolder(
            workclient,
            selectedFile._id,
            root,
            null,
            root,
            intl,
            this.handleOnHideModal
          );
          // Si hay carpeta de destino y el usuario es Admin
        } else if (
          targetFolderId &&
          user.role === "operator" &&
          user.clientRole === "admin"
        ) {
          this.props.moveFolder(
            workclient,
            selectedFile._id,
            targetFolderId,
            null,
            root,
            intl,
            this.handleOnHideModal
          );
          //
        } else if (
          !targetFolderId &&
          user.role === "operator" &&
          user.clientRole === "operator"
        ) {
          sendNotification(
            "warning",
            intl,
            intl.formatMessage({ id: "select_valid_destination" })
          );
          return;
          // Si no es un bunker, hay carpeta de destino y el usuario es Operador
        } else if (!isBunker && targetFolderId && user.role === "operator") {
          this.props.moveFolder(
            workclient,
            selectedFile._id,
            targetFolderId,
            null,
            root,
            intl,
            this.handleOnHideModal
          );
        } else if (targetFolderId && user.role === "operator") {
          sendNotification(
            "warning",
            intl,
            intl.formatMessage({ id: "permission_denied" })
          );
          return;
        }
      } else {
        sendNotification(
          "warning",
          intl,
          intl.formatMessage({ id: "permission_denied" })
        );
        return;
      }
    } else {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "must_select_source_folder" })
      );
      return;
    }
  };

  isFolderDestinationASon = (folderDestination, parents) => {
    const lastItem = parents[parents.length - 1];
    return folderDestination === lastItem;
  };

  handleOnHideModal = () => {
    const { intl, workclient, root, selectedFile } = this.props;
    const isBunker =
      selectedFile.type === "folder" || selectedFile.type === "bunker";
    const prefix = isBunker ? "" : "-file";
    sendNotification(
      "success",
      intl,
      intl.formatMessage({ id: `move-modal-success${prefix}` })
    );
    const location = this.props.history.location.pathname;
    if (!location.includes("explore")) {
      this.props.cleanDataBackRoot();
      // this.props.getRoot(workclient, root)
      this.props.getRoot(workclient, root, true, [], 1, 40);
      this.props.handleHiddenModal();
      return;
    }
    const folderId = location.split("/").pop();
    if (!folderId) return;
    this.props.handleHiddenModal();
    this.props.getExplore(workclient, folderId, 1, null, true, [], 40);
  };

  handleFolderSelect = targetFolderId => {
    this.setState({
      targetFolderId
    });
  };

  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      selectedFile,
      isInFolderAction,
      user
    } = this.props;

    const { targetFolderId } = this.state;

    const isBunker =
      selectedFile.type === "folder" || selectedFile.type === "bunker";
    const prefix = isBunker ? "" : "-file";
    const isOperator = user.role !== "admin" && user.clientRole !== "admin";

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="move-modal"
      >
        <Form>
          <div className="move-modal-title">
            {intl.formatMessage({ id: "move_asset" })}
          </div>
          {/* Asset view */}
          {!isBunker && (
            <div className="move-modal-fileview-wrapper">
              <p className="move-modal-label">{`${intl.formatMessage({
                id: "move-modal-label1-file"
              })}: ${selectedFile.name}`}</p>
              <br />
              <div className="move-modal-view-wrapper">
                {selectedFile.type === "image" &&
                  fileextension(selectedFile.originalURL) === "svg" && (
                    <SVGView
                      comFromMiddleView={true}
                      src={selectedFile.originalURL}
                      assetId={selectedFile._id}
                    />
                  )}
                {selectedFile.type === "image" &&
                  fileextension(selectedFile.originalURL) !== "svg" && (
                    <img
                      alt={selectedFile.name}
                      src={selectedFile.mediaQualityURL}
                      className="move-modal-img"
                    />
                  )}
                {selectedFile.type === "video" && (
                  <VideoView
                    url={selectedFile.lowQualityURL}
                    disableDefaultControls={false}
                    autoPlay={false}
                    muted={false}
                    divWidth={300}
                    from="list"
                  />
                )}
                {selectedFile.type === "document" && (
                  <DocumentView item={selectedFile} from={`middleView`} />
                )}
              </div>
            </div>
          )}
          {/* Folder view */}
          {isBunker && (
            <div className="move-modal-folderview-wrapper">
              <p className="move-modal-label">{`${intl.formatMessage({
                id: "move-modal-label1"
              })}`}</p>
              <Input type="text" value={selectedFile.name} disabled />
            </div>
          )}
          <Form.Item>
            <Breadcrumb
              title={intl.formatMessage({ id: "breadcrumb_placeholder" })}
              placeholder={intl.formatMessage({
                id: `move-modal-placeholder${prefix}`
              })}
              value={targetFolderId}
              handleFolderSelect={this.handleFolderSelect}
              permissionAware={
                user.clientRole === "admin" || user.role === "admin"
                  ? false
                  : true
              }
              permissionsArray={["move"]}
            />
          </Form.Item>
          <Form.Item>
            {!isOperator && isBunker && (
              <Alert
                message={intl.formatMessage({ id: "warning" })}
                description={intl.formatMessage({
                  id: "crudfolder_move_warnings_message"
                })}
                type="warning"
                showIcon
              />
            )}
          </Form.Item>
        </Form>

        <Row type={"flex"} justify={"space-between"}>
          <Button
            size={"large"}
            type={"primary"}
            onClick={this.handleOnMove}
            loading={isInFolderAction}
            className="move-modal-button accept"
          >
            {intl.formatMessage({ id: "move-modal-button" })}
          </Button>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="move-modal-button cancel"
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFile: state.individualSelect.selectedFile,
    workclient: state.client.data ? state.client.data._id : null,
    isInFolderAction: state.client.isInFolderAction,
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    root: state.client.root,
    limit: state.assetsExplore.limit,
    breadcrumb: state.client.breadcrumb,
    keyCollection: state.individualSelect.keyCollection
  };
};

const mapDispatchToProps = {
  setkeyboardEnabled,
  sendShareAssets,
  editFolder,
  getRoot,
  cleanDataBackRoot,
  getExplore,
  moveFolder
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MoveModal))
);
